var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 94,
    viewBox: "0 0 171 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.5 14L19.5 32.5V62L45.5 79L72.5 62V32.5L45.5 14Z",
    stroke: "black",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 35L46 47.5M46 47.5L67 35M46 47.5V72.5",
    stroke: "black",
    strokeWidth: 5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4318 59H81.9091L91.5114 29.9091H102.307L111.909 59H103.386L97.0227 37.9205H96.7955L90.4318 59ZM88.8409 47.5227H104.864V53.4318H88.8409V47.5227ZM114.711 59V29.9091H127.268C129.427 29.9091 131.316 30.3021 132.935 31.0881C134.555 31.8741 135.814 33.0057 136.714 34.483C137.613 35.9602 138.063 37.7311 138.063 39.7955C138.063 41.8788 137.599 43.6354 136.671 45.0653C135.753 46.4953 134.46 47.5748 132.793 48.304C131.136 49.0331 129.2 49.3977 126.984 49.3977H119.484V43.2614H125.393C126.321 43.2614 127.112 43.1477 127.765 42.9205C128.428 42.6837 128.934 42.3097 129.285 41.7983C129.645 41.2869 129.825 40.6193 129.825 39.7955C129.825 38.9621 129.645 38.285 129.285 37.7642C128.934 37.2339 128.428 36.8456 127.765 36.5994C127.112 36.3437 126.321 36.2159 125.393 36.2159H122.609V59H114.711ZM131.756 45.6477L139.029 59H130.45L123.347 45.6477H131.756Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 21.5V3H22",
    stroke: "black",
    strokeWidth: 5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M149.5 2.5L168 2.5V22",
    stroke: "black",
    strokeWidth: 5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M168 72.5V91H148.5",
    stroke: "black",
    strokeWidth: 5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3 73V91.5H23",
    stroke: "black",
    strokeWidth: 5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAr);
export default __webpack_public_path__ + "static/media/ar.f9dadcd78d69b8a788b017016879b183.svg";
export { ForwardRef as ReactComponent };